module.exports = __webpack_public_path__ + "4bc6fc4ed172876b197944c49a2a4661.png";